module.exports = __webpack_public_path__ + "static/img/2014.4c09952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2014.jpg
// module id = 305
// module chunks = 0